import { TextInput } from '@intellecteu/common-ui';
import { Field } from '../ui/form/field';
import { PruneUtcDateTooltip } from '../prune-utc-date-tooltip';

import s from '../backups/styles.module.scss';

export const IdentityDumps = () => {
  return (
    <div className={s.scheduleBackups}>
      <Field
        component={TextInput}
        id="cron"
        name="cron"
        label="Cron"
        tooltipText={<PruneUtcDateTooltip entity="ID dumps" />}
        tooltipMaxWidth={215}
      />

      <Field component={TextInput} id="maxDumps" name="maxDumps" label="Max dump number" type="number" />
    </div>
  );
};
